// Our Components
import Loader from 'components/Loader/index';
import { TertiaryButton, SecondaryButton } from 'components/Button/Button';
import Modal from 'components/Modal/Modal';

function RefreshClientDataModal({
	isModalOpen,
	setIsModalOpen,
	refreshCallBack,
	isLoading
}) {
	return (
		<Modal
			isOpen={isModalOpen}
			handleClose={(e) => {
				e.stopPropagation();
				setIsModalOpen(false);
			}}
			title="Are you sure you'd like to refresh your client's data?"
			subtitle="You are allowed one refresh every 6 months under your payment plan."
		>
			{isLoading && <Loader />}
			{!isLoading && (
				<TertiaryButton onClick={() => refreshCallBack()}>
					Confirm
				</TertiaryButton>
			)}
			<SecondaryButton
				sx={{ marginLeft: 2 }}
				onClick={(e) => {
					e.stopPropagation();
					setIsModalOpen(false);
				}}
			>
				Cancel
			</SecondaryButton>
		</Modal>
	);
}

export default RefreshClientDataModal;
